import { hydrateRoot } from "react-dom/client";
import { RouterClient } from "@tanstack/react-router/ssr/client";
import { createRouter } from "./router";

const domainName = (
  new URL(window.location.href).searchParams.get("d") ||
  window.location.hostname
).replace(/^www\./, "");

const router = createRouter(domainName, "client-side");

if (typeof window !== "undefined") {
  const initSentry = () => {
    setTimeout(() => {
      import("@sentry/react")
        .then((Sentry) => {
          Sentry.init({
            enabled: import.meta.env.PROD,
            dsn: "https://a67413c6e7f37a63ad1a60bc793b5b39@o4511189570355200.ingest.us.sentry.io/4511189662302208",
            integrations: [
              Sentry.tanstackRouterBrowserTracingIntegration(router),
              Sentry.browserTracingIntegration(),
            ],
            // Setting a sample rate is required for sending performance data.
            tracesSampleRate: 1.0,
            sendDefaultPii: true,
            tracePropagationTargets: [
              "localhost",
              /^https:\/\/cms\.purebotswana\.com\/api/,
              /^https:\/\/silvestre\.cr/,
              /^https:\/\/www\.silvestre\.cr/,
            ],
            ignoreErrors: [
              // Ignore third-party and in-app browser bridge errors
              /window\.webkit\.messageHandlers/,
              /window\.ethereum/,
            ],
          });
        })
        .catch((err) => {
          console.error("Failed to load Sentry:", err);
        });
    }, 4000);
  };

  if (document.readyState === "complete") {
    initSentry();
  } else {
    window.addEventListener("load", initSentry);
  }
}

hydrateRoot(document.querySelector("#root"), <RouterClient router={router} />);
